module.exports = __webpack_public_path__ + "static/media/screencapture-react-movieTiny.f2597748.png";